import React from 'react';
import { Copy, Modal, SystemText } from '@salesperformanceint/e4shared';
import config from 'config';

export const Resource = ({ resource, padBottom }) => {
    const [show, setShow] = React.useState(false);

    let buttonText = '';
    switch (resource.type) {
        case 'file':
            buttonText = SystemText('Controls/Resource/Type/FileLink');
            break;
        case 'url':
            buttonText = SystemText('Controls/Resource/Type/URLLink');
            break;
        default: // 'text':
            buttonText = SystemText('Controls/Resource/Type/TextLink');
            break;
    }

    const triggerClick = () => {
        switch (resource.type) {
            case 'file':
                window.open(`${config.storage.URL}${resource.asset?.url}`);
                break;
            case 'url':
                window.open(resource.url);
                break;
            default: // 'text':
                setShow(resource.body);
                break;
        }

        return false;
    };

    return (
        <>
            <button
                data-testid="course-item"
                onClick={triggerClick}
                className={`btn-link prism-content-box anchor-top ${padBottom ? 'mb10' : ''}`}
            >
                <div className="prism-content">
                    <h3 className="mb10 mt10">{resource.name}</h3>
                    <div>{resource?.summary && <p className="truncate-4">{resource.summary}</p>}</div>
                    <span className="btn mt10">{buttonText}</span>
                </div>
            </button>
            <Modal show={show} close={() => setShow('')} title={resource.name} footer={null}>
                <Copy value={show} />
            </Modal>
        </>
    );
};

export default Resource;
